export enum InjectorType {
  WATER = "water_injector",
  GAS = "gas_injector"
}
